import { ReactNode } from 'react';

import {
  SumoMappingJsonZipOperation,
  SumoMappingObjectFieldsFragment,
} from 'core/graphql';

export enum SumoMappingLogFormat {
  Syslog = 'Syslog',
  default = 'default',
  JSON = 'JSON',
  sumofields = 'sumofields',
  BRO = 'BRO',
  Windows = 'Windows',
  Winlogbeats = 'Winlogbeats',
}

export enum SumoMappingSyslogFormat {
  JSON = 'JSON',
  kv = 'kv',
}

export type IngestMappingRow = Omit<
  SumoMappingObjectFieldsFragment,
  '__typename' | 'jsonZipOperations'
> & {
  jsonZipOperations: Omit<SumoMappingJsonZipOperation, '__typename'>[];
};

export interface IngestMappingFormValues {
  enabled: boolean;
  sourceCategory: string;
  vendor: string;
  product: string;
  eventId: string;
  logFormat: string;
  syslogFormat: string;
  syslogDelimiter: string;
  syslogKvDelimiter: string;
  jsonExplode: string;
  jsonZipOperations: Omit<SumoMappingJsonZipOperation, '__typename'>[];
}

export interface IngestMappingFormErrorValues {
  sourceCategory?: string;
  vendor?: string;
  product?: string;
  eventId?: string;
  jsonZipOperations?: {
    [key: number]: {
      keyName?: ReactNode;
      matchKey?: ReactNode;
      matchValue?: ReactNode;
    };
  };
}
